const ORDER_STATUS = [
  { status: "maintenance", name: "Em Manutenção" },
  { status: "sent_franchisor", name: "Enviado para o Franqueador" },
  { status: "review_franchisor", name: "Em analise pelo Franqueador" },
  { status: "refused_franchisor", name: "Recusado pelo franqueador" },
  { status: "validated_franchisor", name: "Validado pelo Franqueador" },
  { status: "confirmed_supplier", name: "Confirmado pelo Fornecedor" },
  { status: "refused_supplier", name: "Recusado pelo Fornecedor" },
  { status: "invoiced_supplier", name: "Faturado pelo Fornecedor" },
  { status: "partial_reconciled", name: "Conciliado Parcial" },
  { status: "reconciled", name: "Conciliado" },
  { status: "cancelled", name: "Cancelado" },
];

const getStatusName = (status) => {
  if (status === "draft") {
    return "Em Manutenção";
  }
  let key = ORDER_STATUS.find((item) => item.status === status);
  if (key === undefined) {
    return "";
  }
  return key.name;
};

export { ORDER_STATUS, getStatusName };
